import axios from 'axios';
import { store } from '../../wrap-with-provider';
import { refreshToken } from '../state/createStore';

// Main API endpoint
//export const APIGW_ROOT = process.env.APIGW_ROOT;
//export const LANDING_URL = process.env.LANDING_URL;

export const APIGW_ROOT = "https://be.emtool.org/v1/";
export const LANDING_URL = 'https://emtool.org/';



//export const APIGW_ROOT = "https://be.emtool.org/v1/";
//export const APIGW_ROOT = "http://qa.emtool.org/v1/";
//export const APIGW_ROOT = "http://localhost:8000/___graphql/";

// Axios instance with interseptors for refreshing the token
export const axiosInstance = axios.create();

let isFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

axiosInstance.interceptors.response.use(
  (response) => {
  return response
  }, 
  (error) => {
  const { config, response: { status } } = error
  const originalRequest = config

  if (status === 401) {
    if (!isFetchingAccessToken) {
      isFetchingAccessToken = true
      store.dispatch(refreshToken()).then((access_token) => {
        isFetchingAccessToken = false
        onAccessTokenFetched(access_token)
      })
    }

    const retryOriginalRequest = new Promise((resolve) => {
      addSubscriber(access_token => {
        originalRequest.headers.Authorization = 'Bearer ' + access_token
        resolve(axios(originalRequest))
      })
    })
    return retryOriginalRequest
  }
  return Promise.reject(error)
})
